import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <div className="bg-emerald-50 border-y border-emerald-100" data-id="element-109">
      <SectionWrapper className="!py-8 md:!py-16" data-id="element-110">
        <div className="max-w-2xl mx-auto text-center flex flex-col items-center" data-id="element-111">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4 md:mb-6 ring-4 ring-emerald-100/50" data-id="element-112">
            <ShieldCheck className="w-6 h-6 md:w-8 md:h-8" data-id="element-113" />
          </div>
          <h2 className="text-[22px] md:text-3xl font-extrabold text-emerald-950 mb-2 md:mb-3 tracking-tight" data-id="element-114">
            7 DÍAS GARANTÍA TOTAL
          </h2>
          <h3 className="text-[16px] md:text-xl font-bold text-emerald-800 mb-1.5 md:mb-2" data-id="element-115">
            Probalo o te devolvemos el 100%
          </h3>
          <p className="text-emerald-700/80 text-[13px] md:text-base font-medium" data-id="element-116">
            Sin preguntas, sin formularios, sin drama.
          </p>
        </div>
      </SectionWrapper>
    </div>;
}